import * as React from "react";
import { connect } from "react-redux";
import { match, useHistory } from "react-router-dom";
import AuditLog from "src/auditLog/AuditLog";
import {
  getMetadataConfig,
  GetMetadataConfigActionType
} from "src/metadata/actions";
import {
  getSpreadHasError,
  getSpreadRejected
} from "src/spread/model/spread/selector";
import CommentView from "../commentView/CommentView";
import { isCreditLensFeatureEnabled } from "../configState/selector";
import DOMableComponent from "../route/DOMableComponent";
import { HideableComponentWrapper } from "../shared/HideableComponent";
import selectorsToProps from "../utils/selectorsToProps";
import {
  uncacheSpread,
  UncacheSpreadActionType,
  unlockSpread,
  UnlockSpreadActionType
} from "./model/spread/actions";
import Spread from "./Spread";

interface SpreadContainerProps {
  unlockSpread: UnlockSpreadActionType;
  uncacheSpread: UncacheSpreadActionType;
  getMetadataConfig: GetMetadataConfigActionType;
  isCreditLensFeatureEnabled: boolean;
  getSpreadHasError: boolean;
  getSpreadRejected: boolean;
  match: match<{
    id: string;
    environmentName?: string;
    status?: string;
    route?: "auditLog" | "comments";
  }>;
}

export const SpreadContainer = (SpreadComponent: React.ComponentType<any>) => {
  return (props: SpreadContainerProps) => {
    const spreadHasError = React.useRef(false);
    const spreadWasRejected = React.useRef(false);
    React.useEffect(() => {
      spreadHasError.current = props.getSpreadHasError;
      spreadWasRejected.current = props.getSpreadRejected;
    }, [props.getSpreadHasError, props.getSpreadHasError]);

    React.useEffect(() => {
      const { id: spreadId } = props.match.params;
      if (props.isCreditLensFeatureEnabled) {
        props.getMetadataConfig({ spreadId });
      }
    }, []);

    React.useEffect(() => {
      const { id: spreadId, environmentName, status } = props.match.params;
      return () => {
        if (
          !props.isCreditLensFeatureEnabled &&
          !spreadHasError.current &&
          !spreadWasRejected.current
        ) {
          props.unlockSpread({
            spreadId,
            environmentName,
            status,
            hasElasticSearchDelay: true
          });
        } else {
          props.uncacheSpread();
        }
      };
    }, []);

    const history = useHistory();
    const { route } = props.match.params;

    return (
      <React.Fragment>
        <SpreadComponent
          isHidden={route}
          match={props.match}
          history={history}
          hidden={route !== undefined}
        />

        {route === "auditLog" && <AuditLog match={props.match} />}
        {route === "comments" && <CommentView match={props.match} />}
      </React.Fragment>
    );
  };
};

export default connect(
  selectorsToProps({
    isCreditLensFeatureEnabled,
    getSpreadHasError,
    getSpreadRejected
  }),
  {
    unlockSpread: unlockSpread.action,
    uncacheSpread: uncacheSpread.action,
    getMetadataConfig: getMetadataConfig.action
  }
)(SpreadContainer(HideableComponentWrapper(DOMableComponent(Spread))));



// WEBPACK FOOTER //
// ./src/spread/SpreadContainer.tsx